"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDescription = exports.setCode = exports.initialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.initialState = {
    code: '',
    description: '',
};
var paymentErrorSlice = toolkit_1.createSlice({
    name: 'paymentError',
    initialState: exports.initialState,
    reducers: {
        setCode: function (state, action) {
            state.code = action.payload;
        },
        setDescription: function (state, action) {
            state.description = action.payload;
        },
    },
});
exports.setCode = (_a = paymentErrorSlice.actions, _a.setCode), exports.setDescription = _a.setDescription;
exports.default = paymentErrorSlice.reducer;
//# sourceMappingURL=paymentErrorSlice.js.map